import {APP_INITIALIZER, Injector, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule, HttpInterceptor} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {AppComponent} from './app.component';
import {KluhManagerModule} from './kluh-manager/kluh-manager.module';
import {ShowAlwaysErrorStateMatcher} from './kluh-manager/show-always-error-state-matcher';
import {FuseSplashScreenService} from '../@fuse/services/splash-screen.service';
import {FuseConfigService} from '../@fuse/services/config.service';
import {FuseNavigationService} from '../@fuse/components/navigation/navigation.service';
import {FuseSharedModule} from '../@fuse/shared.module';
import {FuseModule} from '../@fuse/fuse.module';
import {fuseConfig} from './fuse-config';
import {FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule} from '../@fuse/components';
import {LayoutModule} from './layout/layout.module';

import {ManagerHttpInterceptorService} from './kluh-manager/error/manager-http-interceptor.service';
import {MatPaginatorTranslator} from './kluh-manager/i18n/mat-paginator-translator';
import localePt from '@angular/common/locales/pt';
import localePtExtra from '@angular/common/locales/extra/pt';
import {registerLocaleData} from '@angular/common';
import {ErrorStateMatcher} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {MAT_TABS_CONFIG} from '@angular/material/tabs';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {firebaseJson, preloadFirebaseJson} from './kluh-manager/firebase-config.loader';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getAuth, provideAuth} from '@angular/fire/auth';

registerLocaleData(localePt, 'pt-BR', localePtExtra);

export function errorInterceptorFactory(injector: Injector): HttpInterceptor {
    return new ManagerHttpInterceptorService(injector);
}


const appRoutes: Routes = [
    {
        path: '**',
        redirectTo: 'home'
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, {
    useHash: false,
    enableTracing: false,
    initialNavigation: 'enabledNonBlocking',
    scrollPositionRestoration: 'top',
    preloadingStrategy: PreloadAllModules
}),
        FuseModule.forRoot(fuseConfig),
        FuseSharedModule,
        TranslateModule.forRoot(),
        FuseProgressBarModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        LayoutModule,
        MatIconModule,
        MatSnackBarModule,
        KluhManagerModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    ],
    providers: [
        FuseSplashScreenService,
        FuseConfigService,
        FuseNavigationService,
        { provide: APP_INITIALIZER, useFactory: preloadFirebaseJson, multi: true },
        provideFirebaseApp(() => initializeApp(firebaseJson())),
        provideAuth(() => getAuth()),
        {provide: ErrorStateMatcher, useClass: ShowAlwaysErrorStateMatcher},
        {
            provide: HTTP_INTERCEPTORS,
            useFactory: errorInterceptorFactory,
            multi: true,
            deps: [Injector]
        },
        { provide: MatPaginatorIntl, useFactory: matPaginatorTranslator },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: MAT_TABS_CONFIG, useValue: { stretchTabs: false } }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}


export function matPaginatorTranslator(): MatPaginatorIntl {
    return new MatPaginatorTranslator();
}
